"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../data/store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    savedLocale: function () { return owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture; },
    selectedLocale: function () { return store_1.default().selectedLocale; },
    supportedCultures: function () { return store_1.default().supportedCultures; },
    supportedShortDateFormats: function () { return store_1.default().supportedShortDateFormats; },
})(function getFilteredDateFormatOptions(state) {
    var selectedLocaleName = state.selectedLocale || state.savedLocale;
    var selectedLocale = state.supportedCultures.filter(function (culture) { return culture.Name === selectedLocaleName; })[0];
    if (selectedLocale) {
        return state.supportedShortDateFormats.filter(function (shortDateFormat, index) { return selectedLocale.ShortDateFormatsIndexes.indexOf(index) >= 0; });
    }
    else {
        return [];
    }
});
//# sourceMappingURL=getFilteredDateFormatOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/utils/getFilteredDateFormatOptions.js
// module id = 3726
// module chunks = 2